import { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faUser,
  faFileInvoice,
  faSignOutAlt,
  faArchive,
  faUniversity,
  faWrench,
  faSearch,
  faCalendarDay,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { useAuthenticator } from "@aws-amplify/ui-react";
import "./sidebar.css";

const Sidebar = ({ role, signOut }) => {
  const { user } = useAuthenticator();
  const location = useLocation();
  const isBroker = role === "BROKER";

  const [expanded, setExpanded] = useState(false);

  const isActiveExact = (toPathname, toSearch) => {
    return location.pathname === toPathname && location.search === toSearch;
  };

  return (
    <>
      {expanded && (
        <div
          onClick={() => setExpanded(false)}
          className={"sidebar-overlay"}
        ></div>
      )}
      <div className="ethos-navbar">
        <div className="row navbar-row text-white">
          <div
            onClick={() => setExpanded(true)}
            style={{ fontSize: "1.5em" }}
            className="col-1 text-center"
          >
            <FontAwesomeIcon icon={faBars} />
          </div>
          <div className="col-10 text-center">
            <span className="navbar-title">
              <NavLink to={isBroker ? "/customers" : "/home"}>ETHOS</NavLink>
            </span>
          </div>
        </div>
      </div>
      <div className={"sidebar-main" + (expanded ? " sidebar-expanded" : "")}>
        <div className="d-flex flex-column h-100">
          <NavLink
            onClick={() => setExpanded(false)}
            to={isBroker ? "/customers" : "/home"}
          >
            ETHOS
          </NavLink>
          <hr />
          <div style={{ overflow: "auto", flex: 1 }}>
            {isBroker ? (
              <NavLink onClick={() => setExpanded(false)} to="/customers">
                <span className="sidebar-link">
                  <FontAwesomeIcon icon={faUser} />
                  <span>Clienti</span>
                </span>
              </NavLink>
            ) : (
              <>
              <NavLink onClick={() => setExpanded(false)} to="/activities">
                <span className="sidebar-link">
                  <FontAwesomeIcon icon={faCalendarDay} />
                  <span>Attività</span>
                </span>
              </NavLink>
              <NavLink onClick={() => setExpanded(false)} to="/customers">
                <span className="sidebar-link">
                  <FontAwesomeIcon icon={faUser} />
                  <span>Clienti</span>
                </span>
              </NavLink>
              <NavLink onClick={() => setExpanded(false)} to="/banks">
                <span className="sidebar-link">
                  <FontAwesomeIcon icon={faUniversity} />
                  <span>Banche</span>
                </span>
              </NavLink>
              {(role === "ADMIN" || role === "PRODUZIONE") && (
                <>
                  <NavLink onClick={() => setExpanded(false)} to="/screenings">
                    <span className="sidebar-link">
                      <FontAwesomeIcon icon={faSearch} />
                      <span>Screening</span>
                    </span>
                  </NavLink>
                  <NavLink
                    onClick={() => setExpanded(false)}
                    to="/tributary-screenings"
                  >
                    <span className="sidebar-link">
                      <FontAwesomeIcon icon={faSearch} />
                      <span>Screening Tributario</span>
                    </span>
                  </NavLink>
                  <NavLink
                    onClick={() => setExpanded(false)}
                    to="/delete-report"
                  >
                    <span className="sidebar-link">
                      <FontAwesomeIcon icon={faFileInvoice} />
                      <span>Cancellazione segnalazioni</span>
                    </span>
                  </NavLink>
                </>
              )}
              <NavLink onClick={() => setExpanded(false)} to="/practices-cqs">
                <span className="sidebar-link">
                  <FontAwesomeIcon icon={faFileInvoice} />
                  <span>Cessione del Quinto</span>
                </span>
              </NavLink>
              <NavLink onClick={() => setExpanded(false)} to="/practices-loans">
                <span className="sidebar-link">
                  <FontAwesomeIcon icon={faFileInvoice} />
                  <span>Recuperi PP-Mutuo</span>
                </span>
              </NavLink>
              <NavLink
                onClick={() => setExpanded(false)}
                to="/practices-card-retrieval"
              >
                <span className="sidebar-link">
                  <FontAwesomeIcon icon={faFileInvoice} />
                  <span>Recuperi Carte</span>
                </span>
              </NavLink>
              <NavLink onClick={() => setExpanded(false)} to="/practices-debts">
                <span className="sidebar-link">
                  <FontAwesomeIcon icon={faFileInvoice} />
                  <span>Gestione Debito</span>
                </span>
              </NavLink>
              <NavLink onClick={() => setExpanded(false)} to="/practices-erogation">
                <span className="sidebar-link">
                  <FontAwesomeIcon icon={faFileInvoice} />
                  <span>Erogazioni</span>
                </span>
              </NavLink>
              <NavLink onClick={() => setExpanded(false)} to="/practices-finanthia">
                <span className="sidebar-link">
                  <FontAwesomeIcon icon={faFileInvoice} />
                  <span>Finanthia</span>
                </span>
              </NavLink>
              <NavLink
                onClick={() => setExpanded(false)}
                to="/archives?path=/"
                isActive={() => isActiveExact("/archives", "?path=/")}
              >
                <span className="sidebar-link">
                  <FontAwesomeIcon icon={faArchive} />
                  <span>Archivio</span>
                </span>
              </NavLink>
              <NavLink
                onClick={() => setExpanded(false)}
                to="/archives/my-file?path=/Altri-File/"
                isActive={() =>
                  isActiveExact("/archives/my-file", "?path=/Altri-File/")
                }
              >
                <span className="sidebar-link">
                  <FontAwesomeIcon icon={faArchive} />
                  <span>File</span>
                </span>
              </NavLink>
              </>
            )}

            {!isBroker && role === "ADMIN" ? (
              <>
                <NavLink onClick={() => setExpanded(false)} to="/users">
                  <span className="sidebar-link">
                    <FontAwesomeIcon icon={faUsers} />
                    <span>Utenti</span>
                  </span>
                </NavLink>
                <NavLink
                  onClick={() => setExpanded(false)}
                  to="/services-configuration"
                >
                  <span className="sidebar-link">
                    <FontAwesomeIcon icon={faWrench} />
                    <span>Configura Template</span>
                  </span>
                </NavLink>
              </>
            ) : null}
          </div>
          <hr />
          <div className="sidebar-account  text-white">
            <p>
              Ciao,{" "}
              <NavLink
                className="user"
                onClick={() => setExpanded(false)}
                to="/me"
              >
                {user.username}
              </NavLink>
            </p>
            <div className="sidebar-link" href="#" onClick={signOut}>
              <FontAwesomeIcon icon={faSignOutAlt} />
              <span>Disconetti</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
